import { Draggable, Modal } from '@studiometa/ui';

/**
 * @typedef {{}} ZoomedGalleryProps
 */

/**
 * ZoomedGallery ZoomedGallery.
 * @augments {Base<ZoomedGalleryProps>}
 */
export default class ZoomedGallery extends Modal {
  isOpen = false;
  imagesAreDisplayed = false;
  zoom = 0;
  index = 0;
  paddingSize = 8;

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'ZoomedGallery',
    components: {
      Draggable,
    },
    refs: [
      'close',
      'img[]',
      'plus',
      'minus',
      'thumbs[]',
      'wrapper',
      'prev',
      'next',
      'prevThumb',
      'nextThumb',
      'thumbsWrapper',
    ],
  };

  /**
   *
   */
  mounted() {
    this.currentImage = this.$refs.img[0];
    this.currentThumb = this.$refs.thumbs[0];
    this.zoomedGallery = this.$children.Draggable[0].$el;

    // Thumbs
    if (this.hasThumbs) {
      this.currentPosition = 0;
      this.thumbHeight = this.$refs.thumbs[0].offsetHeight + this.paddingSize;
      this.wrapperHeight = this.$refs.thumbsWrapper.parentElement.offsetHeight;

      this.visibleThumbs = Math.ceil(this.wrapperHeight / this.thumbHeight);
    }
  }

  /**
   *
   */
  onPrevClick() {
    if (this.index === 0) {
      return;
    }

    this.index -= 1;
    this.setCurrentThumbs();
  }

  /**
   *
   */
  onNextClick() {
    if (this.index === this.$refs.img.length - 1) {
      return;
    }

    this.index += 1;
    this.setCurrentThumbs();
  }

  /**
   *
   */
  onCloseClick() {
    this.closeGallery();
  }

  /**
   * OnThumbsClick
   * @param {object} props
   * @param {number} props.index
   */
  onThumbsClick({ index }) {
    this.index = index;
    this.setCurrentThumbs();
    this.setZoomLevel();
  }

  /**
   * Set current state for elements
   */
  setCurrentThumbs() {
    if (!this.hasThumbs) return;

    this.pauseAllVideos();
    this.currentThumb.classList.add('opacity-50');
    this.currentThumb = this.$refs.thumbs[this.index];
    this.currentThumb.classList.remove('opacity-50');
    this.currentThumb.classList.add('!border-grey-20');

    this.currentImage.classList.add('hidden');
    this.currentImage = this.$refs.img[this.index];


    if (this.currentImage.tagName === 'VIDEO') {
      this.currentImage.play();
    }

    this.currentImage.classList.remove('hidden');

    this.setNavState();
  }

  pauseAllVideos() {
    this.$refs.img.forEach((element) => {
      if (element.tagName == 'VIDEO') {
        element.pause();
      }
    });
  }

  /**
   *
   */
  setNavState() {
    if (this.index === 0) {
      this.$refs.prev.classList.add('opacity-20', 'pointer-events-none');
    } else {
      this.$refs.prev.classList.remove('opacity-20', 'pointer-events-none');
    }

    if (this.index === this.$refs.img.length - 1) {
      this.$refs.next.classList.add('opacity-20', 'pointer-events-none');
    } else {
      this.$refs.next.classList.remove('opacity-20', 'pointer-events-none');
    }
  }

  /**
   *
   */
  onPlusClick() {
    if (this.zoom === 5) {
      return;
    }

    this.zoom += 1;
    this.setZoomLevel();
  }

  /**
   *
   */
  onMinusClick() {
    if (this.zoom === 0) {
      return;
    }

    this.zoom -= 1;
    this.setZoomLevel();
  }

  /**
   *
   */
  setZoomLevel() {
    const scale = 1 + this.zoom * 0.6;
    this.$refs.wrapper.style.transform = `scale(${scale})`;
  }

  /**
   *
   * @param {number} index
   */
  openGallery(index) {
    this.isOpen = true;
    document.body.classList.add('overflow-hidden');

    if (this.hasThumbs) {
      this.$refs.next.classList.add('pointer-events-auto');
      this.$refs.prev.classList.add('pointer-events-auto');
    }
    this.index = index;

    this.setCurrentThumbs();
    this.$el.classList.remove('opacity-0', 'pointer-events-none');
  }

  /**
   *
   */
  closeGallery() {
    this.isOpen = false;
    this.$el.classList.add('opacity-0', 'pointer-events-none');

    if (this.hasThumbs) {
      this.$refs.next.classList.remove('pointer-events-auto');
      this.$refs.prev.classList.remove('pointer-events-auto');
    }

    setTimeout(() => {
      document.body.classList.remove('overflow-hidden');
    }, 200);
  }

  /**
   *
   */
  onNextThumbClick() {
    if (this.$refs.thumbs.length - this.visibleThumbs === this.currentPosition) {
      return;
    }

    this.currentPosition += 1;
    this.$refs.thumbsWrapper.style.transform = `translateY(-${this.currentPosition * this.thumbHeight}px)`;
  }

  /**
   *
   */
  onPrevThumbClick() {
    if (this.currentPosition === 0) {
      return;
    }

    this.currentPosition -= 1;
    this.$refs.thumbsWrapper.style.transform = `translateY(-${this.currentPosition * this.thumbHeight}px)`;
  }

  /**
   * Close panel when type on Escape key
   * @param {object} props Props
   * @param {object} props.ESC Escape key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (ESC) {
      this.closeGallery();
    }
  }

  /**
   * @returns {boolean}
   */
  get hasThumbs() {
    return this.$refs.thumbs.length > 0;
  }
}
